/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_AmountInputs */

const en_settings_payments_amount = /** @type {(inputs: Settings_Payments_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

const zh_settings_payments_amount = /** @type {(inputs: Settings_Payments_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`金额`)
};

/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Settings_Payments_AmountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_payments_amount = /** @type {((inputs?: Settings_Payments_AmountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_AmountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_payments_amount(inputs)
	return zh_settings_payments_amount(inputs)
});
export { settings_payments_amount as "settings.payments.amount" }